import {BasePageData} from '../models/strapi/base-page-data';
import {StrapiButtonProps} from '../models/strapi/strapi-button-props';
import {StrapiHeadline} from '../models/strapi/strapi-headline';
import {StrapiMeta} from '../models/strapi/strapi-meta';
import {StrapiStage} from '../models/strapi/strapi-stage';
import {StrapiTextSectionProps} from '../models/strapi/strapi-text-section-props';
import {useLanguageDependentDataSSr} from './useLanguageDependentDataSsr.hook';
import { StrapiTextFieldProps } from '../models/strapi/strapi-text-field-props';

export const useDigitalOriginalsPage =
    useLanguageDependentDataSSr<UseDigitalOriginalsPageData>('digital-originals-page');

interface UseDigitalOriginalsPageData extends BasePageData {
    registerButton: StrapiButtonProps;
    header: StrapiTextSectionProps;
    stage: StrapiStage;
    comingSoonHeadline: StrapiHeadline;
    uniqueInstancesHeadline: StrapiHeadline;
    variantListHeadline: StrapiHeadline;
    meta: StrapiMeta;
    sortBy: StrapiTextFieldProps;
    sortByAlphabetAsc: string;
    sortByAlphabetDesc: string;
    sortByReleaseAsc: string;
    sortByReleaseDesc: string;
}
